export default __webpack_public_path__ + "static/8thWallSocial-3cc195a4d27712eaac3dc65099fd9c24.png";